import React from "react";
import {Button} from "reactstrap";

class EditableNotesCell extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			value: props.originalValue || '',
			isEditing: false,
			isSaving: false,
			error: null
		};
	}

	componentDidUpdate(previousProps) {
		if (previousProps.rowId !== this.props.rowId || previousProps.originalValue !== this.props.originalValue) {
			this.setState({ value: this.props.originalValue || '', isEditing: false, error: null });
		}
	}

	handleChange = (e) => {
		if (this.state.isSaving) return;
		this.setState({
			value: e.target.value,
			isEditing: e.target.value !== (this.props.originalValue || ''),
			error: null
		});
	}

	handleSave = () => {
		this.props.onSave(this.props.rowId, this.state.value);
		this.setState({ isEditing: false });
	}

	handleCancel = () => {
		this.setState({
			value: this.props.originalValue || '',
			isEditing: false,
			error: null
		});
	}

	render() {
		const isEditable = !this.state.isSaving;
		return (
			<div style={{ width: '100%' }}>
				<div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
					<input
						type="text"
						value={this.state.value}
						onChange={this.handleChange}
						placeholder="Click to add notes..."
						aria-label="Admin notes"
						readOnly={!isEditable}
						style={{
							border: 'none',
							background: 'transparent',
							flex: 1,
							padding: '4px',
							fontSize: 'inherit',
							minWidth: 0,
							cursor: isEditable ? 'text' : 'default',
							opacity: isEditable ? 1 : 0.7
						}}
					/>
					{this.state.isEditing && (
						<div style={{ display: 'flex', gap: '4px', marginLeft: '8px' }}>
							<Button
								color="success"
								size="sm"
								onClick={this.handleSave}
								disabled={this.state.isSaving}
								aria-label="Save notes"
								style={{ fontSize: '10px', padding: '2px 6px' }}
							>
								✓
							</Button>
							<Button
								color="secondary"
								size="sm"
								onClick={this.handleCancel}
								disabled={this.state.isSaving}
								aria-label="Cancel notes"
								style={{ fontSize: '10px', padding: '2px 6px' }}
							>
								✕
							</Button>
						</div>
					)}
				</div>
				{this.state.error && <small className="text-danger" role="alert">{this.state.error}</small>}
			</div>
		);
	}
}

export default EditableNotesCell;
